"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronUpSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.14644661,11.8389662 C4.95152327,11.6440429 4.95152327,11.3280097 5.14644661,11.1330864 L9,7.29289322 L12.8551789,11.1325723 C13.0504403,11.3270486 13.0510767,11.6429934 12.8566004,11.8382548 C12.6604899,12.0343667 12.3438015,12.0347502 12.1479283,11.8398235 L9,8.70710678 L5.85429092,11.8397053 C5.65850189,12.0346783 5.34182807,12.0343477 5.14644661,11.8389662 Z" })));
};
ChevronUpSmall.displayName = 'ChevronUpSmall';
exports.default = ChevronUpSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronUpSmall.js.map